import {auth} from 'configs/firebase'

export const signInAnonymously = () => auth.signInAnonymously()
